import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a351b46f7111800142a0b30_1787848616741_218b13b5/extrair_nome/src/app/components/PdfExtractorClient.tsx");
